module.exports = __webpack_public_path__ + "img/conny-stage3-hungry.fd1784b6.png";